export default (theme) => ({
  languageUpdateForm: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: 65,
    borderTop: `1px solid ${theme.palette.disabled.main}`,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      paddingTop: 40,
      marginTop: 20,
    },
  },
  languageSelector: {
    marginBottom: 50,
    minHeight: 60,
    width: '50%',
    [theme.breakpoints.down('lg')]: {
      width: 'calc(100% - 40px)',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 0,
      width: '100%',
    },
  },
});
